export default "<spec-app-type4-fraction-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type4-fraction-table>\n";